<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="code" placeholder="活动编码"></el-input>
                        <el-input v-model="activityName" placeholder="活动名称"></el-input>
                        <!--<el-select v-model="activityType" placeholder="活动分类">
                            <el-option label="分类1" value="分类1"> </el-option>
                            <el-option label="分类2" value="分类2"> </el-option>
                            <el-option label="分类3" value="分类3"> </el-option>
                        </el-select>-->
                        <el-select v-model="activityStatus" placeholder="活动状态">
                            <el-option label="未发布" value="DRAFT"> </el-option>
                            <el-option label="准备中" value="PREPARE"> </el-option>
                            <el-option label="征集中" value="COLLECT"> </el-option>
                            <el-option label="评选中" value="EVALUATE"> </el-option>
                            <el-option label="已结束" value="FINISHED"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="code"
                                label="活动编号"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="activityName"
                                label="活动名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <!--<el-table-column
                                prop="activityCollectStartTime"
                                label="征集时间"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ timeDate(scope.row.activityCollectStartTime) }}——
                                    {{ timeDate(scope.row.activityCollectEndTime) }}
                                </template>
                            </el-table-column>-->
                            <el-table-column
                                prop="worksCount"
                                label="作品数量"
                                header-align="center"
                                show-overflow-tooltip
                                width="80"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createDate"
                                align="center"
                                header-align="center"
                                label="创建时间" width="200">
                            </el-table-column>
                           <!-- <el-table-column
                                prop="activityShowStartDate"
                                align="center"
                                header-align="center"
                                label="公示时间" width="200">
                            </el-table-column>-->
                            <el-table-column
                                prop="voteNum"
                                align="center"
                                header-align="center"
                                label="投票次数">
                            </el-table-column>
                            <el-table-column
                                prop="createDate"
                                align="center"
                                header-align="center"
                                label="投票时间" width="200">
                                <template slot-scope="scope">
                                    {{ timeDate(scope.row.activityVoteStartDate) }}——
                                    {{ timeDate(scope.row.activityVoteEndDate) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="status"
                                align="center"
                                header-align="center"
                                label="活动状态" width="100">
                                <template slot-scope="scope">
                                    {{ getStatus(scope.row.status) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <!--v-if="scope.row.status==='DRAFT' || scope.row.status==='PREPARE'"-->
                                    <el-button type="text" size="small" v-if="scope.row.status==='DRAFT' || scope.row.status==='PREPARE'" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                                    <el-button type="text" size="small" @click="delActivity(scope.row.uuid)">删除</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.status==='DRAFT'" @click="publishActivity(scope.row.uuid)">发布</el-button>
                                    <el-button type="text" size="small" @click="handleManagement('view',scope.row.uuid)">查看</el-button>
                                    <div>
                                        <el-button type="text" size="small" @click="handleManagement('sign',scope.row.uuid)">报名管理</el-button>
                                        <el-button type="text" size="small" @click="handleManagement('work',scope.row.uuid)">作品管理</el-button>
                                        <el-button type="text" size="small" @click="handleManagement('AWARD',scope.row.uuid)">获奖管理</el-button>
                                        <el-button type="text" size="small" @click="handleManagement('JUDGE',scope.row.uuid)">评委管理</el-button>
                                        <el-button type="text" size="small" v-if="scope.row.audit" @click="handleManagement('LEADER',scope.row.uuid)">领导管理</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--编辑/新增-->
        <activity-management-dialog ref="activityManagementDialogRef" @submit="init()"></activity-management-dialog>
        <!--查看详情页-->
        <view-dialog ref="viewDialogRef"></view-dialog>
        <!--报名管理-->
        <sign-dialog ref="signDialogRef"></sign-dialog>
        <!--作品管理-->
        <work-dialog ref="workDialogRef"></work-dialog>
        <!--评委管理-->
        <judges-dialog ref="judgesDialogRef"></judges-dialog>
        <!--领导管理-->
        <leader-dialog ref="leaderDialogRef"></leader-dialog>
    </div>
</template>

<script>
import { getActivityList,deleteActivityInfo,publishActivity } from '../../utils/interface';
// 编辑/新增
import activityManagementDialog from './activeDialog/activityManagementDialog'
// 报名管理
import signDialog from './activeDialog/signDialog'
// 作品管理
import workDialog from './activeDialog/workDialog'
// 评委管理
import judgesDialog from './activeDialog/judgesDialog'
// 领导管理
import leaderDialog from './activeDialog/leaderDialog'
// 查看详情
import viewDialog from './activeDialog/viewDialog.vue'

export default {
    components: {
      activityManagementDialog,
      signDialog,
      workDialog,
      judgesDialog,
      leaderDialog,
        viewDialog,
    },
    data() {
        return {
            code: '',
            activityName: '',
            activityType:'',
            activityStatus: '',
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0
        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120
            return {minHeight: height + 'px'}
        },
    },
    created() {
        this.getList();
    },
    methods: {
        getList(){
            let params = {
                code: this.code,
                activityName:this.activityName,
                status:this.activityStatus,
                current:this.current,
                pageSize:this.pageSize,
            }
            getActivityList(params).then((res)=>{
                this.tableData = res.list;
                this.total = res.total;
            });
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        getStatus(status){
            if(status==='DRAFT'){
                return "未发布";
            }else if(status==='PREPARE'){
                return "准备中";
            }else if(status==='COLLECT'){
                return "征集中";
            }else if(status==='EVALUATE'){
                return "评选中";
            }else if(status==='FINISHED'){
                return "已结束";
            }
        },
        resetData(){
            this.code = '';
            this.activityName = '';
            this.activityType = '';
            this.activityStatus = '';
            this.getList();
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        search(){
           this.current = 1;
           this.getList();
        },
        // 新增/编辑
        toDialog(type,uuid){
            this.$refs.activityManagementDialogRef.init(type,uuid);
        },
        init(){
            this.code = '';
            this.activityName = '';
            this.activityType = '';
            this.activityStatus = '';
            this.current = 1;
            this.getList()
        },
        // 删除
        delActivity(uuid){
            this.$confirm('确定要删除当前活动嘛？', '提示', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
            }).then(() => {
                deleteActivityInfo(uuid).then((res)=>{
                    if(res.success){
                        this.$message.success("删除成功");
                        this.getList();
                    }
                });
            });
        },
        // 发布
        publishActivity(uuid){
            this.$confirm('确定要发布当前活动吗？', '提示', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
            }).then(() => {
                publishActivity({uuid:uuid,status:'PREPARE'}).then((res)=>{
                    if(res.success){
                        this.$message.success("发布成功");
                        this.getList();
                    }
                });
            });
        },
        // 操作
        handleManagement(type,uuid){
          if(type == 'sign'){
              this.$refs.signDialogRef.init(type,uuid)
          }else if(type == 'work'){
              this.$store.commit('updateMenuActiveId', "4028e8a47df9fe6b017dfabfe837005a");
              this.$router.push({ name: "worksManagement", params: { uuid: uuid } });
              //this.$refs.workDialogRef.init(type)
          }else if(type == 'JUDGE'){
              this.$refs.judgesDialogRef.init(type,uuid)
          }else if(type == 'LEADER'){
              this.$refs.leaderDialogRef.init(type,uuid)
          }else if(type == 'view'){
              this.$refs.viewDialogRef.init(type,uuid);
          }else if(type == 'AWARD'){
              //this.$refs.viewDialogRef.init(type,uuid);
              this.$store.commit('updateMenuActiveId', "8a7482dc7e09e20a017e0e59c71f0007");
              this.$router.push({ name: "awardManagement", params: { uuid: uuid } });
          }
        }
    }
}
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activityManagementList.vue